import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { PrismicUtils } from '@segurosvoluntarios_vel/commons-services';
import { CookieService } from 'ngx-cookie-service';
import { CountdownComponent, CountdownEvent } from 'ngx-countdown';
import { BaseEstadoPagoComponent } from 'src/app/pago/containers/estado-pago/base-estado/base-estado-pago.component';
import { Cookie } from 'src/app/pago/enums/Cookie.enum';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';
import { Pago } from 'src/app/pago/models/Pago.model';
import { PagoFacade } from 'src/app/pago/services/pago-facade/pago.facade';
import { loadPago } from 'src/app/store/actions/pago.action';

@Component({
  selector: 'app-pendiente',
  templateUrl: './pendiente.component.html',
  styleUrls: [
    './pendiente.component.scss',
    '../base-estado/base-estado-pago.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PendienteComponent extends BaseEstadoPagoComponent
  implements OnInit, OnDestroy {
  @Input() pago: Pago;
  @Input() contenido: ContenidoDeEstadoDePago;
  @Input() tenant: string;
  static readonly MAXIMO_INTENTOS_CONSULTAR_ESTADO_PAGO = 3;
  @ViewChild('countdown') countdown: CountdownComponent;
  intervaloConsultarEstadoPago = 59;
  timeout: number;
  cookieEstadoPago: string;
  fechaExpiracionCookie: Date;
  contadorCookie = 1;

  constructor(
    private pagoFacade: PagoFacade,
    private cookieService: CookieService,
    public prismicUtils: PrismicUtils
  ) {
    super(prismicUtils);
  }

  ngOnInit(): void {
    this.inicializar(this.pago, this.contenido, this.tenant);
  }

  configurarCookieInicial() {
    this.cookieEstadoPago = `${Cookie.ESTADO_PAGO}${this.pago.idPago}`;
    this.fechaExpiracionCookie = new Date();
    this.fechaExpiracionCookie.setTime(
      this.fechaExpiracionCookie.getTime() +
        Cookie.TIEMPO_EXPIRACION_EN_MINUTOS * 60 * 1000
    );
  }

  handleChangeCountdown(estadoCountdown: CountdownEvent) {
    this.configurarCookieInicial();
    if (this.cookieService.check(this.cookieEstadoPago)) {
      this.validarEstadoCookie(estadoCountdown);
    } else {
      this.crearActualizarCookieEstadoPago(String(this.contadorCookie));
    }
  }

  validarEstadoCookie(estadoCountdown: CountdownEvent) {
    const valorCookieEstadoPago = Number(
      this.cookieService.get(this.cookieEstadoPago)
    );

    // Validación para que solo se permita consultar el estado de pago 3 veces.

    if (
      valorCookieEstadoPago <=
      PendienteComponent.MAXIMO_INTENTOS_CONSULTAR_ESTADO_PAGO
    ) {
      // Esta condición es necesaria, ya que el emit de
      // countdown tiene varios acciones y solo debe aplicar cuando es done.

      if (estadoCountdown.action === Cookie.DONE) {
        this.consultarEstadoPago(valorCookieEstadoPago);
      }
    } else {
      this.intervaloConsultarEstadoPago = 0;
      this.eliminarTimeOut();
    }
  }

  consultarEstadoPago(valorCookieEstadoPago) {
    this.pagoFacade.dispatch(loadPago({ idPago: this.pago.idPago }));

    // El restart debe estar dentro de un timeout por un error
    // en la librería, esta solución es temporal.
    // Url incidencia: https://github.com/cipchk/ngx-countdown/issues/91

    this.timeout = setTimeout(() => {
      this.countdown.restart();
    });
    this.crearActualizarCookieEstadoPago(
      String(valorCookieEstadoPago + this.contadorCookie)
    );
  }

  crearActualizarCookieEstadoPago(valor: string) {
    this.cookieService.set(
      this.cookieEstadoPago,
      valor,
      this.fechaExpiracionCookie
    );
  }

  eliminarTimeOut() {
    clearTimeout(this.timeout);
  }

  ngOnDestroy() {
    this.eliminarTimeOut();
  }
}
